import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ScrollArea, ScrollBar } from './ui/scroll-area';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function RegionFilter({ activeRegion = null }) {
  const [regions, setRegions] = useState([]);

  useEffect(() => {
    fetchRegions();
  }, []);

  const fetchRegions = async () => {
    try {
      const response = await axios.get(`${API}/regions`);
      setRegions(response.data);
    } catch (error) {
      console.error('Failed to fetch regions:', error);
    }
  };

  return (
    <div className="mb-8" data-testid="region-filter">
      <div className="flex items-center mb-3">
        <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-[#52525B] dark:text-[#A1A1AA]">
          Region
        </h3>
      </div>
      <ScrollArea className="w-full">
        <div className="flex space-x-2 pb-4">
          <Link
            to="/"
            className={`px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
              !activeRegion
                ? 'bg-[#0055FF] text-white'
                : 'bg-white dark:bg-[#121212] text-gray-700 dark:text-gray-300 border border-black/10 dark:border-white/10 hover:border-[#0055FF] dark:hover:border-[#3377FF]'
            }`}
            data-testid="region-all"
          >
            Alle Regionen
          </Link>
          {regions.map((region) => (
            <Link
              key={region.id}
              to={`/region/${region.id}`}
              className={`px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
                activeRegion === region.id
                  ? 'bg-[#0055FF] text-white'
                  : 'bg-white dark:bg-[#121212] text-gray-700 dark:text-gray-300 border border-black/10 dark:border-white/10 hover:border-[#0055FF] dark:hover:border-[#3377FF]'
              }`}
              data-testid={`region-${region.id}`}
            >
              {region.name}
            </Link>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
}

export default RegionFilter;
